import React, { createContext, useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { API } from './Constants';
import { useRollbar } from '@rollbar/react';

const DataTypeContext = createContext();

const DataType = (props) => {
    const [dataTypes, setDataTypes] = useState({});
    const [dataTypesLoaded, setDataTypesLoaded] = useState(false);
    const [isDeliveryEnabled, setIsDeliveryEnabled] = useState(false);
    const [useProvisionsAndNotes, setUseProvisionsAndNotes] = useState(false);
    const rollbar = useRollbar();

    async function fetchData() {
        const requestTime = new Date().toISOString();
        const startTime = performance.now();

        const res = await fetch(API.DATA_TYPES_URL, {
            cache: 'no-cache',
        });

        const responseTime = new Date().toISOString();
        const duration = performance.now() - startTime;

        const responseHeaders = {};
        for (let [key, value] of res.headers.entries()) {
            responseHeaders[key] = value;
        }

        await res
            .json()
            .then((data) => {
                setDataTypes(data);
                setDataTypesLoaded(true);
                setIsDeliveryEnabled(Boolean(data?.vromoIntegrationNetwork));
                setUseProvisionsAndNotes(Boolean(data?.useProvisionsAndNotes));

                if (data && !data.appointmentOptions) {
                    const responseInfo = {
                        requestTime,
                        responseTime,
                        duration: `${duration.toFixed(2)}ms`,
                        status: res.status,
                        statusText: res.statusText,
                        responseHeaders,
                        dataTypes: data
                    };

                    rollbar.warning('Missing appointmentOptions in DataTypes', { response: responseInfo });
                }
            })
            .catch(() => {
                setDataTypes({});
                setDataTypesLoaded(false);
                setIsDeliveryEnabled(false);
                setUseProvisionsAndNotes(false);
            });
    }

    useEffect(() => {
        fetchData();
    }, []);

    const loadingResponse = (
        <div className="d-flex justify-content-center">
            <Spinner animation="grow" />
        </div>
    );
    const normalResponse = (
        <DataTypeContext.Provider value={{ dataTypes, isDeliveryEnabled, useProvisionsAndNotes }}> {props.children} </DataTypeContext.Provider>
    );

    return dataTypesLoaded ? normalResponse : loadingResponse;
};

export { DataType, DataTypeContext };
